import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const updateUser = async (id, body) => {
	const url = `/auth/usuario?usuario_id=${id}`;
	const response = await api.patch(url, body);
	return response.data;
};
export const useUpdateUsers = (id: number, body: any) => {
	const toast = useToast();
	const queryClient = useQueryClient();
	const history = useHistory();

	return useMutation(() => updateUser(id, body), {
		onSuccess: () => {
			queryClient.invalidateQueries(['users-list']);
			history.goBack();
			toast({
				title: 'Atualizado com sucesso!',
				description: 'Usuário(a) atualizado(a) com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao atualizar usuário(a).'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
